"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RemodelingCtaBand() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2,
    once: true
  });
  return <section id="remodelingctaband" data-nav="dark" className="relative overflow-hidden bg-secondary py-20 text-secondary-foreground sm:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="mx-auto flex max-w-3xl flex-col items-center text-center transition-all duration-500 ease-out" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(15px)"
      }}>
          <div className="mb-6 h-0.5 w-14 bg-primary" aria-hidden="true" />

          <h2 className="font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
            Begin your Brookhaven whole-home remodeling project
          </h2>

          <p className="mt-5 max-w-2xl text-base text-secondary-foreground/80 sm:text-lg">
            Schedule a personalized consultation to review your architectural plans, discuss tailored finishes, and establish a clear timeline for your home.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5">
            <Button asChild size="lg" className="w-full bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 sm:w-auto">
              <Link to="/ContactRequestAnEstimatePage">
                <span>Get a Free Estimate</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full border-secondary-foreground/20 bg-transparent text-secondary-foreground shadow-xs hover:bg-secondary-foreground/10 hover:text-secondary-foreground sm:w-auto">
              <a href="tel:+14708479076">
                <Phone className="size-4" />
                <span>Call (470) 847-9076</span>
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}